import UniqueInDatatable from './UniqueInDatatable'
export default (Validator) => {
  Validator.extend('naf-uniqueindatatable', UniqueInDatatable, ['fieldName', 'runRule', 'dataType', 'config', 'rootModel'])
}
